import { StringFormatter } from '@agoda/react-handyman';
import { Box, Icon, Typography } from '@drone-js/core';
import React from 'react';
import { mapStateToProps, Props } from 'component/page/detail/PopoverCalendar/CalendarPriceInfoText.selectors';
import { connect } from 'react-redux';

const CalendarPriceInfoText: React.FC<Props> = (props) => {
    return (
        <Box display="flex" py="8" px="0" flexDirection="column" data-testid="calendar-currency-information">
            <Box display="flex" justifyContent="start" alignItems="start" pb="8">
                <Icon id="line.symbol.currency" size="16" pe="8" color="base.subtle" />
                <Typography variant="body-s" textColor="base.subtle">
                    {StringFormatter.format(props.cms['292100'], props.currency)}
                </Typography>
            </Box>
            <Box display="flex" justifyContent="start" alignItems="start">
                <Icon id="line.symbol.circle-info" size="16" pe="8" color="base.subtle" />
                <Typography variant="body-s" textColor="base.subtle" textAlign="start">
                    {props.cms['305872']}
                </Typography>
            </Box>
        </Box>
    );
};

CalendarPriceInfoText.displayName = 'CalendarPriceInfoText';

export default connect(mapStateToProps)(CalendarPriceInfoText);
